import { render } from "./FriendCollectionView.vue?vue&type=template&id=2157279a&scoped=true"
import script from "./FriendCollectionView.vue?vue&type=script&lang=js"
export * from "./FriendCollectionView.vue?vue&type=script&lang=js"

import "./FriendCollectionView.vue?vue&type=style&index=0&id=2157279a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2157279a"]])

export default __exports__